/* eslint-disable */
import React from "react";
// INTERFACES
import { AddReadWriteRelationshipInterface } from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentAddReadWriteRelationship({
	data,
	setData,
}: {
	data: AddReadWriteRelationshipInterface;
	setData: (newValue: AddReadWriteRelationshipInterface) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{/** ************************* */}
			{/** BODY */}
		</div>
	);
}
